<script lang="ts">
export default {
  name: 'KkBadge',
}
</script>

<script setup lang="ts">

export interface Props {
  text: string
  backgroundColor: string
  textColor: string
}

const props = defineProps<Props>()
</script>

<template>
  <div :class="$style.badge" :style="{ backgroundColor: props.backgroundColor, color: props.textColor }">
    {{ props.text }}
  </div>
</template>
<style lang="scss" module>
@import "../../../../../stylesheets/biz_spa/foundation/_var.scss";
.badge {
  text-align: center;
  font-size: 10px;
  line-height: 12px;
  word-wrap: break-word;
  padding: 4px 6px;
  border-radius: 12px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
</style>
